module.exports = __webpack_public_path__ + "static/media/cloudsec3.49e8be0f.png";